import React, { FC } from 'react'
import useWindowSize from './util/useWindowSize'
import classNames from 'classnames'

export type GalleryItemType = {
  img: string
  width: number
}

type GalleryType = {
  imageOption?: 1 | 2 | 3
  images: [
    GalleryItemType,
    GalleryItemType,
    GalleryItemType,
    GalleryItemType,
    GalleryItemType,
    GalleryItemType,
    GalleryItemType,
    GalleryItemType,
  ]
}

const Gallery: FC<GalleryType> = ({ imageOption = 1, images }) => {
  const size = useWindowSize()
  return (
    <div className={'container px-0 gallery mt-lg-21 mt-14 mb-lg-27 mb-14'}>
      <div className={'offset-lg-5 z-index-1 text-lg-start text-center'}>
        <img
          loading='lazy'
          className='img-fluid ms-xxl-4 ms-lg-8'
          alt={'1'}
          src={images[0].img}
          width={images[0].width}
        />
      </div>
      <div
        className={classNames(
          'mt-lg-n30 z-index-0 ms-lg-0 ms-4',
          [1, 3].includes(imageOption) || !size.isSmOrLower ? 'mt-8' : 'mt-n2',
          imageOption === 3 ? 'mt-xxl-n48' : 'mt-xxl-n42',
        )}
      >
        <img
          className='img-fluid'
          loading='lazy'
          alt={'2'}
          src={images[1].img}
          width={images[1].width}
        />
      </div>
      <div
        className={'text-end mt-xxl-n50 mt-xl-n42 mt-lg-n22 mt-n10 z-index-0'}
      >
        <img
          className={classNames(
            'img-fluid',
            [1, 3].includes(imageOption) || !size.isSmOrLower
              ? 'ms-sm-0 ms-30'
              : 'me-4',
          )}
          loading='lazy'
          alt={'3'}
          src={images[2].img}
          width={images[2].width}
        />
      </div>
      <div
        className={classNames(
          'text-center mt-xxl-n38 mt-lg-n24 z-index-1',
          [1, 3].includes(imageOption) || !size.isSmOrLower ? 'mt-8' : 'mt-n2',
        )}
      >
        <img
          className='img-fluid'
          loading='lazy'
          alt={'4'}
          src={images[3].img}
          width={images[3].width}
        />
      </div>
      <div
        className={classNames(
          'mt-lg-n16 ms-sm-0',
          [1, 3].includes(imageOption) || !size.isSmOrLower
            ? 'mt-10 ms-n8'
            : 'ms-4 mt-n10',
          { 'z-index-1': imageOption === 2 && size.isSmOrLower },
        )}
      >
        <img
          className={classNames('img-fluid', {
            'position-relative': imageOption === 2 && size.isSmOrLower,
          })}
          loading='lazy'
          alt={'5'}
          src={images[4].img}
          width={images[4].width}
        />
        <img
          className={classNames(
            'img-fluid ms-xxl-46 ms-sm-38 mt-lg-0',
            [1, 3].includes(imageOption) || !size.isSmOrLower
              ? 'mt-n10 ms-18'
              : 'd-sm-inline d-block mt-n2 ms-auto me-4',
          )}
          loading='lazy'
          alt={'6'}
          src={images[5].img}
          width={images[5].width}
        />
      </div>
      <div
        className={classNames(
          'mt-lg-n22 offset-sm-1',
          [1, 3].includes(imageOption) || !size.isSmOrLower ? 'mt-n10' : 'mt-8',
        )}
      >
        <img
          className={classNames(
            'img-fluid ms-sm-0',
            [1, 3].includes(imageOption) || !size.isSmOrLower
              ? 'ms-4'
              : 'ms-12',
          )}
          loading='lazy'
          alt={'7'}
          src={images[6].img}
          width={images[6].width}
        />
      </div>
      <div
        className={classNames(
          'mt-lg-n22 mt-lg-n14',
          [1, 3].includes(imageOption) || !size.isSmOrLower ? 'mt-12' : 'mt-8',
          imageOption === 3
            ? 'mt-xxl-n38 text-xl-end text-center'
            : 'mt-xxl-n30 text-center',
        )}
      >
        <img
          className={classNames(
            'img-fluid',
            imageOption === 3 ? 'me-xxl-48 me-xl-38' : '',
          )}
          loading='lazy'
          alt={'8'}
          src={images[7].img}
          width={images[7].width}
        />
      </div>
    </div>
  )
}

export default Gallery
